import AttendAchievementLockPage from './AttendAchievementLockPage';

export default AttendAchievementLockPage;
